export default () => {
  const data = {
    pos_integrated: false,
    sheet_url:
      'https://docs.google.com/spreadsheets/d/1hYo5jhyxtUL6QEQqRCrWGq5uDsUoVQLp-ZOZQlk_uBc',
    sheet_id: '1hYo5jhyxtUL6QEQqRCrWGq5uDsUoVQLp-ZOZQlk_uBc',
    id: '32f133040ca44ca7936a1ff901f276ac',
    imported_at: '2018-09-12T15:08:38.542609Z',
    items: [
      {
        id: '32f133040ca44ca7936a1ff901f276ac',
        image_url: '',
        alcohol: false,
        pre_packed: null,
        classification_id: '1ef102c89604439096ee01959a9fd4a0',
        tax_category_id: 'c267be8582954734a97ec269510e5569',
        version_id: '82a03f1e1f6545d395992a9c57380ac3',
        item_translations: [
          {
            id: '572094da4d46475493995f1a4c73fbb8',
            name: 'Burger',
            description: '',
            item_id: '32f133040ca44ca7936a1ff901f276ac',
            language_code: 'en',
          },
        ],
        portions: [
          {
            id: '12325f75ec9f43be9ed47347923cb090',
            price: 2000,
            calories: 125,
            sort_order: 2,
            pos_id: 'pos_id_innit',
            default_portion: false,
            item_id: '32f133040ca44ca7936a1ff901f276ac',
          },
        ],
      },
    ],
    options: [
      {
        version_id: '861c9a28d40f457792961cdb1c871770',
        tax_category_id: 'c267be8582954734a97ec269510e5569',
        price: 750,
        alcohol: false,
        pre_packed: true,
        calories: null,
        pos_id: 'pos_id_innit',
        option_translations: [
          {
            name: 'Mild',
            operational_name: 'Mild',
            language_code: 'en',
            version_id: '861c9a28d40f457792961cdb1c871770',
          },
        ],
      },
    ],
    version_id: '82a03f1e1f6545d395992a9c57380ac3',
    unique_code: 'u23h93t72g3io2h3092ggi2g032023',
    created_at: '2018-09-12T15:08:38.542609Z',
    updated_at: '2018-09-12T15:08:38.542609Z',
  };

  const headers = new Headers({
    'Content-Type': 'application/json',
  });
  const response = new Response(JSON.stringify(data), { headers });
  const request = new Promise((resolve) =>
    setTimeout(() => {
      resolve(response);
    }, 1000),
  );

  return request;
};
